import React from 'react';

import { UseCreateTemplateFromReportModalLogic } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/CreateTemplateFromReportModal.logic';
import classes from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/CreateTemplateFromReportForm.module.scss';
import { Radio } from 'components/DesignSystem/Radio';

interface Props {
    logic: UseCreateTemplateFromReportModalLogic['logic'];
}

export const RadioSelection = ({ logic }: Props) => {
    return (
        <div className={classes.optionContainer}>
            <Radio
                onChange={() => {
                    logic.setRadioToNewTemplate();
                }}
                value={'new'}
                checked={logic.radioOption === 'new'}
                name={'new'}
                label={'Create new Template'}
            />

            <Radio
                onChange={() => {
                    logic.setRadioToOverwrite();
                }}
                value={'overwrite'}
                checked={logic.radioOption === 'overwrite'}
                name={'overwrite'}
                label={'Overwrite existing Template'}
            />
        </div>
    );
};
